(function($) {
    $(() => {
        if (!algolia_localize.page_settings.knowledge_base_search) {
            return;
        }

        function replaceUrlParam(url, paramName, paramValue) {
            if (paramValue == null) {
                paramValue = '';
            }
            var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
            if (url.search(pattern) >= 0) {
                return url.replace(pattern, '$1' + paramValue + '$2');
            }
            url = url.replace(/[?#]$/, '');
            return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
        }

        const searchClient = algoliasearch(algolia_localize.app_id, algolia_localize.search_key);

        let sections = [
            {
                type: 'knowledge-base',
                title: 'Knowledge base',
                sources: ['source:https-www-asetek-com-simsports'],
                number_of_hits_per_page_default: '100',
                number_of_hits_per_page_filtered_state: '100'
            }
        ];

        let global_index_name = 'simsports live';

        let search;

        function template(item, type, index) {
            let template;

            var featured_image =
                item['featured_image'] ||
                algolia_localize.plugin_url + 'assets/img/placeholder_pic.png';

            return template;
        }

        function searchSetup() {
            $(sections).each(function(i, e) {
                var currentFacetFilters = [];
                currentFacetFilters.push([`type:knowledge-base`]);

                if (e.sources.length > 0) {
                    currentFacetFilters.push(['https-www-asetek-com-simsports']);
                }

                var currentHitsPerPage = e.number_of_hits_per_page_default;
                if (hasTab != '' && hasTab != undefined) {
                    currentHitsPerPage = e.number_of_hits_per_page_filtered_state;
                    if (hasTab != e.title) {
                        $(`#${e.title}.js-section-result`).addClass('hidden');
                    }
                }

                if (i == 0) {
                    search = instantsearch({
                        indexName: global_index_name,
                        searchClient,
                        // routing: true,
                        routing: {
                            router: instantsearch.routers.history({
                                createURL({ qsModule, location, routeState }) {
                                    const { origin, pathname, hash } = location;
                                    const queryString = qsModule.stringify(routeState);

                                    var currentTab = $.getUrlParameter('tab');
                                    var hasTab = false;

                                    if (currentTab != '' && currentTab != undefined) {
                                        hasTab = true;
                                    }

                                    if (hasTab) {
                                        if (queryString) {
                                            return `${origin}${pathname}?tab=${currentTab}&${queryString}`;
                                        } else {
                                            return `${origin}${pathname}?tab=${currentTab}`;
                                        }
                                    } else {
                                        if (queryString) {
                                            return `${origin}${pathname}?${queryString}`;
                                        } else {
                                            return `${origin}${pathname}`;
                                        }
                                    }
                                },
                                stateMapping: instantsearch.stateMappings.simple()
                            })
                        },
                        searchFunction(helper) {
                            if (helper.state.query == '') {
                                helper.setQueryParameter('filters', 'show_default:true');
                                helper.search();
                            } else {
                                helper.setQueryParameter(
                                    'filters',
                                    'show_default:true OR show_default:false'
                                );
                                helper.search();
                            }
                        }
                    });

                    search.on('render', () => {
                        $('.js-section-result').animate({ opacity: 1 });
                    });

                    const catArray = {
                        simsportslocal: 'knowledge base'
                    };

                    const typesArray = ['knowledge-base'];

                    // Helper for the render function

                    if (algolia_localize.page_settings.searchbox) {
                        const renderIndexListItem = function({ indexId, hits }) {
                            let logo = 'company';

                            return `
    
    
                  ${
                      indexId === 'simsports live'
                          ? ''
                          : ` ${hits.length != 0 ? `<p class="cat-p">Knowledge base </p>` : ``}
                    ${hits
                        .map(function(hit, hitIndex) {
                            logo = 'simsports';

                            return `
                            <li>
                              <img class="algolia-hit-logo" src="${
                                  algolia_localize.plugin_url
                              }/assets/img/${logo}.svg" alt="logo">
                              <a href="${
                                  hit.url
                              }">${instantsearch.highlight({ attribute: 'title', hit })}</a>
                            </li>
                          `;
                        })
                        .join('')}
                  `
                  }
            `;
                        };

                        // Create the render function

                        const renderAutocomplete = (renderOptions, isFirstRender) => {
                            const {
                                indices,
                                currentRefinement,
                                refine,
                                widgetParams
                            } = renderOptions;

                            if (isFirstRender) {
                                const input = document.createElement('input');
                                const ul = document.createElement('ul');

                                input.classList.add('own-input');
                                input.classList.add('js-own-input');

                                ul.classList.add('own-ul');

                                input.addEventListener('input', event => {
                                    refine(event.currentTarget.value);
                                });

                                widgetParams.container.appendChild(input);
                                widgetParams.container.appendChild(ul);
                            }

                            widgetParams.container.querySelector('input').value = currentRefinement;

                            widgetParams.container.querySelector('ul').innerHTML = indices
                                .map(renderIndexListItem)
                                .join('');
                        };

                        // Create the custom widget
                        const customAutocomplete = instantsearch.connectors.connectAutocomplete(
                            renderAutocomplete
                        );

                        // Instantiate the custom widget
                        search.addWidgets([
                            customAutocomplete({
                                container: document.querySelector('#autocomplete-knowledge-base')
                            })
                        ]);
                    }
                }

                $(document).ready(function() {
                    
                    $('.js-own-input').attr('placeholder', algolia_localize.search_placeholder);
                    $('.js-own-input').on('focusin', function() {
                        $('.own-ul').addClass('show');
                    });

                    $('.js-own-input').on('focusout', function(e) {
                        setTimeout(function() {
                            $('.own-ul').removeClass('show');
                        }, 300);
                    });
                });

                search.addWidgets([
                    instantsearch.widgets
                        .index({
                            indexName: global_index_name,
                            indexId: 'search_' + e.type
                        })
                        .addWidgets([
                            instantsearch.widgets.configure({
                                hitsPerPage: currentHitsPerPage,
                                facetFilters: currentFacetFilters
                            })
                        ])
                ]);
            });
        }

        var hasTab = $.getUrlParameter('tab');

        if (hasTab != '' && hasTab != undefined) {
            $(`.js-category-item[data-tab="${hasTab}"]`).addClass('active');
        } else {
            $('.js-category-item[data-tab=""]').addClass('active');
        }

        searchSetup();
        search.start();

        $('.js-category-item').on('click', function(e) {
            e.preventDefault();
            var tab = $(this).data('tab');

            var url = window.location.href.split('?')[0];
            if (tab != '') {
                url = replaceUrlParam(url, 'tab', tab);
            }

            var currentQuery = $.getUrlParameter(`${global_index_name}[query]`);
            if (currentQuery != '' && currentQuery != undefined) {
                url = replaceUrlParam(url, `${global_index_name}[query]`, currentQuery);
            }
            window.location.href = encodeURI(url);
        });

        /*History go back if same domain*/
        $('.js-algolia-history-go-back').on('click', function(e) {
            e.preventDefault();
            var currentUrl = window.location.href;
            var $goto = $(this).data('goto');
            if (document.referrer.indexOf(algolia_localize.siteurl) >= 0) {
                history.go(-1);
                setTimeout(function() {
                    // if location was not changed in 100 ms, then there is no history back
                    if (currentUrl === window.location.href) {
                        window.location.href = $goto;
                    }
                }, 100);
            } else {
                window.location.href = $goto;
            }
        });
    });
})(jQuery);
